
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import { TFilterProduct, TFilterSelect, TFilterTreeSelect } from '@/common/components/redesigned/Filter/types/filter';
  import { MenuModes } from '@/common/components/redesigned/TreeMultiselect/types';
  import { TProductItem } from '@/common/components/redesigned/TreeSelectionProducts/types';
  import { TSelectOption } from '@/common/types/select';

  import { SELECT_TYPE_FILTER_OPTIONS } from '../../constants/options';
  import { COUNTRIES_LEVEL_EVENTS_LABELS, REGIONS_RF_LEVEL_EVENTS_LABELS } from '../../constants/tree';
  import { VED_COMMON_ACTIONS_NAME, VED_COMMON_GETTERS_NAME } from '../../store/vedCommon/name';
  import { TRegionAggregatedFilter } from '../../types/region-aggregated';
  import { yearMonthPeriodTreeFilterConfig } from '../../utils/filter';
  import FilterDetailsVed from '../common/FilterDetailsVed.vue';
  import FilterFactoryVed from '../common/FilterFactoryVed.vue';

  export default defineComponent({
    name: 'RegionAggregatedFilter',
    components: {
      FilterDetailsVed,
      FilterFactoryVed,
    },
    emits: {
      searchFilter: (filter: Partial<TRegionAggregatedFilter>) => filter,
      updateFilter: (filter: Partial<TRegionAggregatedFilter>) => filter,
      updateProductText: (productText: string) => productText,
    },
    props: {
      defaultFilter: {
        type: Object as PropType<TRegionAggregatedFilter>,
        required: true,
      },
      readonlyPermissionCode: {
        type: Number,
      },
    },
    data(): {
      productText: string;
    } {
      return {
        productText: '',
      };
    },
    created() {
      this.searchCountriesTree();
      this.searchRegionsRfTree();
    },
    computed: {
      ...mapGetters({
        getCountriesTree: VED_COMMON_GETTERS_NAME.getCountriesTree,
        getRegionsRfTree: VED_COMMON_GETTERS_NAME.getRegionsRfTree,
      }),
      getFiltersConfig(): [
        TFilterTreeSelect,
        TFilterTreeSelect,
        TFilterProduct,
        TFilterTreeSelect,
        TFilterSelect<TSelectOption>,
      ] {
        return [
          yearMonthPeriodTreeFilterConfig,
          {
            type: 'tree-select',
            label: 'Страна',
            options: this.getCountriesTree,
            vModel: 'countries',
            required: true,
            isSingleMode: true,
            levelEventsLabels: COUNTRIES_LEVEL_EVENTS_LABELS,
            menuMode: MenuModes.COMBINED_MODAL,
          },
          {
            type: 'product',
            vModel: 'product',
            required: true,
            multiple: false,
            valueUpdated: (value: TProductItem[]) => {
              const isUpdateProductText = !this.productText;

              this.productText = value.map((item) => item.name).join(', ');

              if (!isUpdateProductText) return;

              this.updateProductText();
            },
          },
          {
            type: 'tree-select',
            label: 'Субъект РФ',
            options: this.getRegionsRfTree,
            vModel: 'regionsRf',
            required: true,
            levelEventsLabels: REGIONS_RF_LEVEL_EVENTS_LABELS,
            menuMode: MenuModes.COMBINED_MODAL,
          },
          {
            type: 'select',
            label: 'Тип выборки',
            options: SELECT_TYPE_FILTER_OPTIONS,
            vModel: 'selectTypeId',
            valueProp: 'value',
            labelProp: 'label',
            required: true,
          },
        ];
      },
    },
    methods: {
      ...mapActions({
        searchCountriesTree: VED_COMMON_ACTIONS_NAME.searchCountriesTree,
        searchRegionsRfTree: VED_COMMON_ACTIONS_NAME.searchRegionsRfTree,
      }),
      searchFilter(filter: Partial<TRegionAggregatedFilter>) {
        this.$emit('searchFilter', filter);
        this.updateProductText();
      },
      updateFilter(filter: Partial<TRegionAggregatedFilter>) {
        this.$emit('updateFilter', filter);
      },
      updateProductText() {
        this.$emit('updateProductText', this.productText);
      },
    },
  });
